<template>
  <div class="card-container" :class="[card.format]">
    <div class="card-story" :class="[card.position]">
      <div v-if="card.elements" class="card-elements">
        <animate-element :controller="controller" v-for="(element, id) in elements" :element="element" :key="id" />
      </div>

      <div v-if="bgImage" class="card-bg-image">
        <img :src="bgImage" />
      </div>
      
      <div class="card-meta">
        <div class="card-date"><span v-html="card.date"></span></div>
        <div v-if="card.format == 'year'" class="card-chapter">
          <div><img :src="imgIcon" class="img-icon" /></div>
        </div>
        <h2 class="card-title" v-html="card.title"></h2>
        <div v-if="card.format == 'year'" class="card-period">
          {{ chapter.period }}
        </div>
        <div class="card-share">
          <share-story :url="url" :card="card" />
        </div>
      </div>
      <div v-if="imgHeader" class="card-header">
        <img :src="imgHeader" />
      </div>
      
      <div v-if="headerSticky" class="card-header-sticky">
          <img :src="headerSticky" />
        </div>

      <div v-if="card.content" class="card-content-container">
        <div class="card-content" v-html="card.content"></div>
      </div>
      <div v-if="imgFooter" class="card-header">
        <img :src="imgFooter" />
      </div>
    </div>
      
  </div>
</template>

<script>

import animateElement from './animateElement.vue'
import shareStory from './shareStory.vue'

export default {
  name: "cardStory",
  components: {
    animateElement,
    shareStory
  },
  props: {
    card: Object,
    elements: Array,
    controller: Object,
    chapter: Object,
    url: String
  },
  computed: {
    imgHeader() {
      if(this.card.imgHeader)
        return require(`../assets/${this.card.imgHeader}`)
      return false
    },
    headerSticky() {
      if(this.card.headerSticky)
        return require(`../assets/${this.card.headerSticky}`)
      return false
    },
    bgImage() {
      if(this.card.bgImage)
        return require(`../assets/${this.card.bgImage}`)
      return false
    },
    imgFooter() {
      if(this.card.imgFooter)
        return require(`../assets/${this.card.imgFooter}`)
      return false
    },
    imgIcon() {
      if(this.chapter.icon)
        return require(`../assets/${this.chapter.icon}`)
      return false
    }
  }
}

</script>
